import html3pdf from 'html3pdf';

export const createMovimientosPDF = async (datos, imgUrl) => {

  let user_data = JSON.parse(localStorage.getItem("siam-user-data"));
  const usuario_nombre_apellido = user_data ? user_data.nombre + ", " + user_data.apellido : "Usuario Desconocido";
  const fecha_desde = datos.fecha_desde || "Sin fecha desde";
  const fecha_hasta = datos.fecha_hasta || "Sin fecha hasta";

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  // Generar filas dinámicamente
  const serviceRows = datos.datos
    .map(item => `
      <tr>
        <td>${item.name}</td>
        <td>${item.total}</td>
      </tr>
    `)
    .join('');

  const htmlContent = `
  <html>
  <head>
    <style>
      body {
        font-family: Arial, sans-serif;
        margin: 20px;
      }
      h1, h2, h3, h4 {
        color: #333;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
      }
      th, td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: center;
        font-size: 10px;
      }
      th {
        background-color: #f2f2f2;
      }
      .label {
        display: inline-block;
        padding: 5px;
        color: white;
        border-radius: 3px;
      }
      .label-primary { background-color: #337ab7; }
      .label-warning { background-color: #f0ad4e; }
      .label-danger { background-color: #d9534f; }
      .label-success { background-color: #5cb85c; }
      img {
        max-width: 100px;
        max-height: 100px;
      }
      .centered {
        text-align: center;
      }
      .cover-page {
        display: flex;
        flex-direction: column;
        justify-content: top;
        align-items: center;
      }
      .cover-logo {
        max-width: 10000px;
        max-height: 10000px;
        height: 50px;
      }
      @page {
        margin: 20mm 20mm;
      }
      .page-break {
        page-break-before: always;
      }
      .hidden {
        display: none;
      }
      .header-table {
        width: 100%;
        border: none;
        margin-bottom: 20px;
      }
      .header-table td {
        border: none;
        vertical-align: middle;
      }
      .text-content {
        text-align: center;
        padding-left: 20px;
      }
      .text-content h3 {
        margin: 0;
        padding: 0;
        font-size: 15px;
      }
      .text-content h3:not(:last-child) {
        margin-bottom: 5px;
      }
      tr {
        page-break-inside: avoid;
      }
    </style>
  </head>
  <body>
    <table class="header-table">
      <tr>
    
        <td class="text-content">
          <h3>Informe de Movimientos</h3>
        </td>
      </tr>
    </table>

    <!-- Primera Tabla -->
    <table>
      <tr>
        <td colspan="2"><strong>Usuario:</strong> </td>
        <td colspan="2"> ${usuario_nombre_apellido} </td>
      </tr>
      <tr>
        <td><strong>Fecha Desde:</strong></td>
        <td>${formatDate(fecha_desde)}</td>
        <td><strong>Fecha Hasta:</strong></td>
        <td>${formatDate(fecha_hasta)}</td>
      </tr>
    </table>

    <!-- Segunda Tabla -->
    <table>
      <thead>
        <tr>
          <th>Servicio</th>
          <th>Cantidad</th>
        </tr>
      </thead>
      <tbody>
        ${serviceRows}
      </tbody>
    </table>


  </body>
  </html>
`;

  const opt = {
    margin: [15, 15, 15, 15],
    filename: `Movimientos-${formatDate(fecha_desde)} - ${formatDate(fecha_hasta)}.pdf`,
    image: { type: 'jpeg', quality: 1 },
    html2canvas: { scale: 2, logging: false, scrollX: 0, scrollY: -window.scrollY, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  };

  await html3pdf().from(htmlContent).set(opt).save();
};

export default createMovimientosPDF;
